<template>
  <div class="org3">
    <div class="scholar-container clearfix">
      <div class="scholar-l">
        <h3>学者分析</h3>
        <el-table :data="tableData" height="700" border style="width: 100%">
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <a target="_blank" @click="goFormalExp(scope.row.name)">{{scope.row.name}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="value" label="资源"></el-table-column>
        </el-table>
      </div>
      <div class="scholar-r">
        <!-- <el-input style="width:200px;" v-model="keyword" clearable></el-input>
        <el-button
          style="margin-left:30px;margin-bottom:30px;"
          :loading="loading"
          type="primary"
          icon="el-icon-search"
          @click="search"
        >搜索</el-button> -->
        <div class="pie" v-loading="loading1">
          <h3>本机构内学科分布</h3>
          <PieChart id="PieChart" height="300px" width="100%" :chart-data="pieChartData" />
        </div>
        <div class="line" v-loading="loading1">
          <h3>研究方向成果分布</h3>
          <LineChart id="PatentChart" height="300px" width="100%" :lienList="lineChartData" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Common from '@/components/commonOrg/Common'
import PieChart from '@/components/Charts/PieChart'
import LineChart from '@/components/Charts/LineChart'
import { getRes } from '@/api/organization'

export default {
  name: 'Overview',
  props: {
    allData: Object,
    orgData: Object
  },
  components: {
    Common,
    PieChart,
    LineChart
  },
  watch: {
    allData: {
      deep: true,
      handler (val) {
        this.tableData = val.tops.topCreators
      }
    }
  },
  data () {
    return {
      tableData: [],
      loading: false,
      loading1: false,
      keyword: '',
      pieChartData: [],
      lineChartData: {
        countVal: [],
        countYear: []
      }
    }
  },
  methods: {
    search () {
      this.loading = true
      this.loading1 = true
      const data =
        this.orgData.nameAlt === null
          ? {
            name: [this.orgData.name],
            code: ['J', 'I'],
            year: [2010, 2018],
            keyword: this.keyword
          }
          : {
            name: [
              this.orgData.name,
              this.orgData.nameAlt,
              this.orgData.shortNameAlt
            ],
            code: ['J', 'I'],
            year: [2010, 2018],
            keyword: this.keyword
          }
      getRes(data)
        .then(res => {
          this.loading = false
          const countVal = []
          const countYear = []
          res.data.tops.topYears
            .sort((a, b) => {
              return a.name - b.name
            })
            .forEach(item => {
              countVal.push(item.value)
              countYear.push(item.name)
            })
          this.loading1 = false
          this.pieChartData = res.data.tops.topSubjects.slice(0, 10)
          this.lineChartData.countVal = countVal
          this.lineChartData.countYear = countYear
          this.tableData = res.data.tops.topCreators
        })
        .catch(err => {
          console.log(err)
        })
    },
    goFormalExp (name) {
      console.log(this.allData)
      let institute = this.orgData.name
      let routeData = this.$router.resolve({
        name: 'Detail',
        query: {name: name, institute: institute}
      })
      window.open(routeData.href, '_blank')
    }
  },
  mounted () {
    this.search()
    if (Object.keys(this.allData).length) {
      this.tableData = this.allData.tops.topCreators
    }
  }
}
</script>

<style lang="scss">
h3 {
  margin-bottom: 10px;
}
.org3 {
  .scholar-container {
    margin-bottom: 50px;
    .scholar-l {
      float: left;
      width: 50%;
    }
    .scholar-r {
      float: right;
      width: 45%;
      .pie {
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/organization/Orgs/org3.vue